import { apiConnector } from "./apiconnector"; // adjust path if needed
import { templateEndpoints } from "./apis"; // define your endpoints here
import { toast } from "react-hot-toast";

// Destructure endpoints
const { CREATE_TEMPLATE_API, GET_TEMPLATES_API, DELETE_TEMPLATE_API } = templateEndpoints;

// Get all templates
export const getTemplates = async () => {
  try {
    const response = await apiConnector(
      "GET",
      GET_TEMPLATES_API,
      null,
    );
    return response.data; // Return data so that calling function can dispatch
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to fetch templates");
    throw error;
  }
};

// Create a template
export const createTemplate = async (templateData) => {
  try {
    const response = await apiConnector(
      "POST",
      CREATE_TEMPLATE_API,
      templateData,
      {withCredentials:true}
    );
    toast.success("Template created successfully");
    return response.data.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to create template");
    throw error;
  }
};

// Delete a template
export const deleteTemplate = async (templateId) => {
  try {
    const response = await apiConnector(
      "DELETE",
      `${DELETE_TEMPLATE_API}/${templateId}`,
      null,
      {withCredentials:true}
    );
    toast.success("Template deleted successfully");
    return response.data; // or response.message
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete template");
    throw error;
  }
};
